import dayjs from "dayjs";
import { t } from "i18next";

function formatDateTime(dateString) {
  if (!dateString) return;
  const date = dayjs(dateString);
  return date.format(t("human_format.datetime"));
}

export default formatDateTime;
